import React from 'react';
import { NavLink } from 'react-router-dom';
import { UtensilsCrossed, LogOut, Sun, Moon } from 'lucide-react';
import { useTheme } from '../context/ThemeProvider';
import { cn } from './ui/cn';

const navItems = [
  { to: '/takeaway', label: 'TakeAway' },
  { to: '/reservations', label: 'Reservas' },
  { to: '/statistics', label: 'Estatísticas' },
  { to: '/admin', label: 'Admin' },
];

const linkClasses = ({ isActive }) =>
  cn(
    'px-3 py-2 rounded-lg text-sm font-semibold transition-colors',
    isActive
      ? 'bg-brand-soft text-brand'
      : 'text-muted hover:bg-surface-2 hover:text-foreground'
  );

// Quantos pedidos de reembolso há por tratar, a piscar ao lado do TakeAway. É o
// que se vê de qualquer página — o som pode não se ouvir numa cozinha cheia.
const RefundBadge = ({ count }) =>
  count > 0 ? (
    <span
      className="ml-1.5 inline-grid min-w-[1.25rem] place-items-center rounded-full bg-status-pending px-1.5 text-xs font-bold text-white motion-safe:animate-alerta"
      title={`${count} pedido(s) de reembolso por tratar`}
      aria-label={`${count} pedido(s) de reembolso por tratar`}
    >
      {count}
    </span>
  ) : null;

const TopNav = ({ onLogout, refundRequests = 0 }) => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <header className="sticky top-0 z-30 h-16 bg-surface/80 backdrop-blur-md border-b border-border">
      <div className="max-w-7xl mx-auto flex h-full items-center justify-between gap-4 px-4 sm:px-6">
        <div className="flex items-center gap-2.5">
          <span className="grid h-9 w-9 place-items-center rounded-xl gradient-brand text-white shadow-md">
            <UtensilsCrossed className="h-5 w-5" />
          </span>
          <span className="text-lg font-bold tracking-tight">
            <span className="text-gradient-brand">TOMS</span>{' '}
            <span className="text-foreground">Admin</span>
          </span>
        </div>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <NavLink key={item.to} to={item.to} className={linkClasses}>
              {item.label}
              {item.to === '/takeaway' && <RefundBadge count={refundRequests} />}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            onClick={toggleTheme}
            className="grid h-9 w-9 place-items-center rounded-lg border border-border text-muted hover:text-foreground hover:bg-surface-2 transition-colors"
            aria-label={isDark ? 'Ativar modo claro' : 'Ativar modo escuro'}
            title={isDark ? 'Modo claro' : 'Modo escuro'}
          >
            {isDark ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
          </button>
          <button
            onClick={onLogout}
            className="flex items-center gap-1.5 rounded-lg bg-status-canceled px-3 py-2 text-sm font-semibold text-white shadow-sm hover:brightness-110 transition-all"
          >
            <LogOut className="h-4 w-4" />
            <span className="hidden sm:inline">Sair</span>
          </button>
        </div>
      </div>

      {/* Mobile nav */}
      <nav className="md:hidden flex items-center gap-1 overflow-x-auto border-t border-border px-4 py-1.5">
        {navItems.map((item) => (
          <NavLink key={item.to} to={item.to} className={linkClasses}>
            {item.label}
            {item.to === '/takeaway' && <RefundBadge count={refundRequests} />}
          </NavLink>
        ))}
      </nav>
    </header>
  );
};

export default TopNav;
